import { useTranslation } from '@/hooks/useDebugTranslations'

export const DepartureNoSailing = () => {
  const { t } = useTranslation()

  return (
    <div
      className="bg-semantic-global-background-white mb-semantic-global-lg p-semantic-global-lg border-semantic-global-border-light typography-body-md-regular text-semantic-global-text-default gap-semantic-global-lg flex h-[107px] w-full flex-col items-center justify-center lg:border"
      data-e2e="departure-no-sailing"
    >
      <div className="typography-body-md-regular text-semantic-global-text-default text-center">
        <div>{t('NO-SALINGS')}</div>
        <div>{t('PLEASE-TRY-DIFFERENT-TIME-OR-DATE')}</div>
      </div>
    </div>
  )
}
